module.exports = __webpack_public_path__ + "static/img/bg_report.5cc09e62.png";